import React from 'react'
import { Modal } from 'react-bootstrap'


export default class isiSaldo extends React.Component {
    render() {
        const { balance,setShowSaldo,cancelSaldo,changehandlerpin,
            errors,nominal,otherShow,hide, updBalance,def_nom} = this.props
        return (
            <div class="mb-10">
                <Modal show={setShowSaldo} >
                    <Modal.Header>
                        <Modal.Title>Isi Saldo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="form-group">
                            <select class="form-control" style={{ border: "solid blue 1px"}} value={balance} onChange={changehandlerpin("balance")} onClick = {otherShow}>
                            {
                        def_nom.map(data => { 
                                return (
                                    <option value={data.nominal}>{data.nominal}</option>     
                                    )
                            })
                        }                                {
                        nominal.map(data => { 
                                return (
                                    <option value={data.nominal}>{data.nominal}</option>     
                                    )
                            })
                        }   <option value = "others">Nominal lain</option>
                            </select>
                            <span className="error"> {errors["balance"]}</span>
                            </div>
                            <div class="form-group">
                                <input type="number" class="form-control" id = "others" style={{ border: "solid blue 1px",display:hide }} 
                                 onChange={changehandlerpin("other_balance")} placeholder="minimun is Rp.10000" />
                                <span className="error"> {errors["other_balance"]}</span>
                            </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" class="btn btn-primary" onClick = {updBalance}>Top Up</button>
                        <button type="button" class="btn btn-secondary" onClick={cancelSaldo} >Cancel</button>
                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}

